module.exports = __webpack_public_path__ + "img/color-3x.dc075103.svg";